var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "createWorkPermit" },
    [
      _c(
        "TMSHeader",
        {
          attrs: {
            title: _vm.$t("workPermit.title"),
            buttons: _vm.buttons,
            needGoback: true,
            goBack: _vm.back,
            extendStickyClass: "createWorkPermit_stickyHeader",
            dotOption: _vm.dotOption,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "pointer work-permit-status",
              class: _vm.statusStyle,
              attrs: { slot: "status" },
              on: { click: _vm.lifecycleModal },
              slot: "status",
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm._f("customStatusLabel")(_vm.status))),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.workerInfoLastUpdatedText
            ? _c(
                "i",
                {
                  staticClass: "work-permit-last-updated",
                  attrs: { slot: "status-detail" },
                  slot: "status-detail",
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.workerInfoLastUpdatedText) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("Lifecycle", {
        ref: "workPermitLifecycle",
        attrs: {
          modalId: "work-permit-modules-lifecycle-modal",
          commentAttr: _vm.lifecycleCommentAttrs.comments,
          histories: _vm.histories || [],
          type: "workPermit",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "createWorkPermit_allInfo" },
        [
          _c("ProjectInfo", { attrs: { projectPermit: _vm.parentPermit } }),
          _vm._v(" "),
          _c(
            "TabsContainer",
            {
              class: ["createWorkPermit_tabs", _vm.tabsHighLight],
              attrs: { tabNames: _vm.tabNames },
            },
            [
              _c("GeneralInfo", {
                ref: "step1_generalInfo",
                attrs: {
                  slot: "tab-0",
                  isEdit: _vm.isProjectAvailable,
                  isProjectAvailable: _vm.isProjectAvailable,
                },
                slot: "tab-0",
              }),
              _vm._v(" "),
              _c("WorkerInfo", {
                ref: "step2_workerInfo",
                attrs: { slot: "tab-1", isEdit: _vm.isProjectAvailable },
                slot: "tab-1",
              }),
              _vm._v(" "),
              _c("HoistingHotWork", {
                ref: "step3_hoistingsInfo",
                attrs: {
                  slot: "tab-2",
                  isEdit: _vm.isProjectAvailable,
                  isProjectAvailable: _vm.isProjectAvailable,
                },
                slot: "tab-2",
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "deleteWorkPermitModal",
        attrs: {
          modalId: "deleteWorkPermitModal_" + _vm.workPermitId,
          confirmTitle: _vm.isRejected
            ? _vm.deleteRejectedWPHint
            : _vm.$t("workPermit.deleteWPConfirmHint"),
        },
      }),
      _vm._v(" "),
      _c(
        "Modal",
        { ref: "tooManyHoistingModal", attrs: { showCloseBtn: false } },
        [
          _c("p", { staticClass: "tooManyHoistingModalMessage" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.projectTooManyHoistingMessage) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "button" },
                on: { click: _vm.closeTooManyHoistingModal },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.close")) + "\n      "
                ),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }